'use client';
import ICPAreaCard from '../../common/icp-area-card';
import { UseCaseWhyItMatter } from '@/types/global';

const WhyItMatter = ({ title, description, data }: { title: string, description: string, data: UseCaseWhyItMatter[] }) => {
    return (
        <section className="desilo-service5-section section-padding-top overflow-hidden">
            <div className="container custom-container">
                <div className="row">
                    <div className="col-12">
                        <h2 className="title desilo__header">{title}</h2>
                        <p className="hero2-content-text">{description}</p>
                    </div>
                </div>
                <div className="row gx-4 gy-5 row-padding-top">
                    {/* service card start */}
                    {data.map((item, i) => (
                        <div key={i} className="col-md-6 col-lg-3">
                            <ICPAreaCard data={item} />
                        </div>
                    ))}
                    {/* service card end */}
                </div>
            </div>
        </section>
    );
};

export default WhyItMatter;
